import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import EmbroideryPage from '../pages/embroidery/page';
import GalleryPage from '../pages/gallery/page';
import ContactPage from '../pages/contact/page';
import ShoppingPage from '../pages/shopping/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/embroidery', element: <EmbroideryPage /> },
  { path: '/gallery', element: <GalleryPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/shopping', element: <ShoppingPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
